import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=5400f112&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports